<template>
  <v-card class="metric-card" elevation="2">
    <v-card-text>
      <div class="d-flex align-center justify-space-between mb-2">
        <div class="metric-icon" :class="accentClass">
          <v-icon>{{ icon }}</v-icon>
        </div>
      </div>
      <div class="metric-title">{{ title }}</div>
      <div class="metric-value">{{ value }}</div>
      <div class="metric-subtitle">{{ subtitle }}</div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'MetricCard',
  props: {
    title: { type: String, required: true },
    value: { type: [String, Number], required: true },
    subtitle: { type: String, default: '' },
    icon: { type: String, required: true },
    accent: { type: String, default: 'primary' }
  },
  computed: {
    accentClass () {
      return `accent-${this.accent}`
    }
  }
}
</script>

<style scoped lang="scss">
.metric-card {
  border-radius: 16px;
  transition: transform 0.2s;

  &:hover {
    transform: translateY(-2px);
  }
}

.metric-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;

  &.accent-primary {
    background: rgba(65, 14, 71, 0.15);
    color: #410E47;
  }

  &.accent-success {
    background: rgba(16, 185, 129, 0.15);
    color: #10B981;
  }

  &.accent-danger {
    background: rgba(239, 68, 68, 0.15);
    color: #EF4444;
  }
}

.metric-title {
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #410E47;
  margin-bottom: 8px;
}

.metric-value {
  font-size: 32px;
  font-weight: 700;
  line-height: 1;
  margin-bottom: 4px;
}

.metric-subtitle {
  font-size: 13px;
  color: #64748B;
}
</style>
